import angular from 'angular';
import template from './template.html';
import './style.scss';

export const ASTERISK = '*';

export class TFTInput {
    innerValue = '';

    /* @ngInject */
    constructor($filter) {
        this.$filter = $filter;
    }

    $onChanges() {
        this.innerValue = angular.copy(this.value);
        const postfix = this.getPostfix(this.required, !this.hideAsterisk);
        this.formattedPlaceholder = this.getFormattedPlaceholder(this.placeholder, postfix);
    }

    valueChange() {
        const value = angular.copy(this.innerValue);

        this.onChange({ value });
    }

    getPostfix(required, showAsterisk) {
        if (required && showAsterisk) {
            return `${ASTERISK}`;
        }

        return '';
    }

    getFormattedPlaceholder(placeholder, postfix) {
        const translatedPlaceholder = this.$filter('translate')(placeholder);

        return `${translatedPlaceholder} ${postfix}`;
    }
}

export const TFTInputConfig = {
    template,
    bindings: {
        value: '<',
        required: '<',
        hideAsterisk: '<',
        type: '@',
        testId: '@',
        placeholder: '@',
        className: '@',
        onChange: '&',
        onFocus: '&',
    },
    controller: TFTInput,
    controllerAs: 'tftInputCtrl',
};

angular
    .module('TALENYA-FE')
    .component('tftInput', TFTInputConfig);
